import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=04cfce49&scoped=true&"
var script = {}
import style0 from "./Contact.vue?vue&type=style&index=0&id=04cfce49&scoped=true&lang=css&"
import style1 from "./Contact.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cfce49",
  null
  
)

export default component.exports